export const registration = {
  hero: {
    title: 'EachTeachに参加',
    subtitle: '私たちと一緒に言語学習の旅を始めましょう'
  },

  // Step0: 登録種別の分岐
  step0: {
    title: '登録方法を選択',
    subtitle: 'あなたに合った登録方法を選んでください',
    individual: {
      title: '個人として登録',
      desc: '言語交換に参加する個人ユーザー向け'
    },
    org: {
      title: '団体として登録',
      desc: '語学学校・サークル・個人事業主など団体の管理者向け'
    },
    member: {
      title: '団体メンバーとして登録',
      desc: '所属団体の月次コードをお持ちの方向け'
    },
    haveAccount: 'すでにアカウントをお持ちですか？',
    login: 'ログイン'
  },

  // Google ログイン
  google: {
    button: 'Googleで続ける',
    or: 'または',
    processing: 'Googleへ移動中...'
  },

  // 団体登録フロー
  org: {
    title: '団体として登録',
    steps: {
      account: 'アカウント',
      type: '団体種別',
      details: '団体情報',
      document: '身分証',
      terms: '規約同意'
    },
    type: {
      title: '団体種別を選択',
      subtitle: 'あてはまる団体の種類を選んでください',
      individual_tutor: '個人事業主（家庭教師など）',
      individual_tutor_desc: '個人で語学指導を行う方',
      language_school: '言語教育機関（語学学校・塾）',
      language_school_desc: '法人として語学教育を提供する機関',
      community: '言語学習コミュニティ（大学サークル等）',
      community_desc: '非営利・準営利の学習コミュニティ'
    },
    details: {
      title: '団体情報を入力',
      subtitle: 'マッチングと請求に使用します',
      nameLabel: '団体名 *',
      namePlaceholder: '例: EachTeach Language School',
      emailLabel: '団体メールアドレス *',
      emailPlaceholder: 'contact@example.com',
      websiteLabel: 'ウェブサイト URL',
      websitePlaceholder: 'https://example.com',
      snsLabel: 'SNS URL',
      snsPlaceholder: 'https://instagram.com/...',
      schedulingLabel: 'スケジューリング方式',
      schedulingHint: '生徒主軸か団体管理者主軸かを選べます（あとで変更可能）',
      schedulingStudent: '生徒主軸（生徒が希望日時を送信）',
      schedulingManager: '団体管理者主軸（管理者が日程を調整）'
    },
    document: {
      title: '身分証のアップロード',
      subtitle: '団体の実在性確認のため、身分証または団体登録証をアップロードしてください',
      label: '身分証ファイル *',
      hint: 'JPEG / PNG / PDF・10MB まで。安全に非公開で保管されます。',
      uploading: 'アップロード中...',
      uploaded: 'アップロード済み',
      selectFile: 'ファイルを選択',
      changeFile: 'ファイルを変更'
    },
    terms: {
      title: '規約への同意',
      subtitle: 'お申し込み前にご確認ください',
      agreePrefix: '',
      termsLink: '利用規約',
      and: 'と',
      privacyLink: 'プライバシーポリシー',
      agreeSuffix: 'に同意します'
    },
    submit: '団体登録を申請',
    submitting: '申請中...',
    back: '戻る',
    next: '次へ',
    success: {
      title: '団体登録を申請しました',
      body: '運営による承認をお待ちください。承認後にメールでお知らせします。',
      toLogin: 'ログインページへ'
    },
    validation: {
      typeRequired: '団体種別を選択してください',
      detailsRequired: '団体名とメールアドレスを入力してください',
      urlInvalid: 'URL は http(s):// で始まる形式で入力してください',
      documentRequired: '身分証をアップロードしてください',
      termsRequired: '利用規約とプライバシーポリシーに同意してください',
      fileTooLarge: 'ファイルサイズは 10MB 以下にしてください',
      fileType: 'JPEG / PNG / PDF のいずれかをアップロードしてください',
      uploadFailed: 'アップロードに失敗しました。もう一度お試しください'
    }
  },

  // 団体メンバー登録フロー
  member: {
    codeTitle: '団体コードを入力',
    codeSubtitle: '所属団体から配布された月次コードを入力してください',
    codeLabel: '団体コード',
    codePlaceholder: '例: AB12CD34',
    verify: 'コードを確認',
    checking: '確認中...',
    invalidCode: 'コードが無効か、有効期限が切れています',
    verifiedOrg: '確認済み団体',
    planFree: 'Free',
    planPro: 'Pro',
    validUntil: '有効期限',
    back: '戻る',
    noCode: 'コードが分からない場合は',
    contactUs: 'お問い合わせ'
  },

  // 共通: アカウント作成
  account: {
    title: 'アカウント作成',
    subtitle: 'メールアドレスとパスワードを設定してください',
    emailLabel: 'メールアドレス',
    passwordLabel: 'パスワード',
    passwordPlaceholder: '8文字以上',
    confirmLabel: 'パスワード確認',
    confirmPlaceholder: 'もう一度入力',
    next: '次へ',
    processing: '処理中...',
    passwordMismatch: 'パスワードが一致しません',
    passwordMin: 'パスワードは8文字以上にしてください',
    signupFailed: 'アカウント作成に失敗しました',
    emailConfirmTitle: '確認メールを送信しました',
    emailConfirmBody: '宛に確認メールをお送りしました。メール内のリンクをクリックしてアカウントを有効化してください。',
    emailConfirmSpam: 'メールが届かない場合は迷惑メールフォルダもご確認ください。',
    toLogin: 'ログインページへ'
  },


  form: {
    name: {
      label: '氏名',
      placeholder: '氏名を入力してください'
    },
    
    gender: {
      label: '性別',
      placeholder: '性別を選択してください',
      female: '女性',
      male: '男性',
      other: 'その他'
    },
    
    nativeLanguage: {
      label: '母国語',
      placeholder: '母国語を選択してください'
    },
    
    secondNativeLanguage: {
      label: '第二母国語（任意）',
      placeholder: '第二母国語を選択してください（該当する場合）'
    },
    
    learningLanguage: {
      label: '学習したい言語',
      placeholder: '学習したい言語を選択してください'
    },
    
    secondLearningLanguage: {
      label: '第二学習言語（任意）',
      placeholder: '第二学習言語を選択してください（該当する場合）'
    },
    
    country: {
      label: '居住国',
      placeholder: '居住国を入力してください'
    },
    
    timezone: {
      label: 'タイムゾーン',
      placeholder: 'タイムゾーンを選択してください'
    },
    
    email: {
      label: 'メールアドレス',
      placeholder: 'your.email@example.com'
    },
    
    availability: {
      label: '利用可能な曜日と時間',
      description: '各曜日で利用可能な時間帯を選択してください'
    },
    
    languages: {
      japanese: '日本語',
      korean: '韓国語',
      english: '英語',
      chinese: '中国語',
      spanish: 'スペイン語',
      french: 'フランス語',
      german: 'ドイツ語',
      portuguese: 'ポルトガル語',
      italian: 'イタリア語',
      russian: 'ロシア語',
      arabic: 'アラビア語',
      hindi: 'ヒンディー語',
      thai: 'タイ語',
      vietnamese: 'ベトナム語',
      other: 'その他'
    },
    
    days: {
      monday: '月曜日',
      tuesday: '火曜日',
      wednesday: '水曜日',
      thursday: '木曜日',
      friday: '金曜日',
      saturday: '土曜日',
      sunday: '日曜日'
    },
    
    agreement: {
      terms: '利用規約',
      and: 'と',
      privacy: 'プライバシーポリシー',
      agree: 'に同意します'
    },
    
    validation: {
      required: '必須項目を入力してください',
      availability: '少なくとも1つの曜日と時間帯を選択してください',
      terms: '利用規約とプライバシーポリシーに同意してください'
    },
    
    status: {
      success: '登録が完了しました！まもなくご連絡いたします。',
      error: 'エラーが発生しました。もう一度お試しください。'
    },
    
    submit: {
      button: '登録を送信',
      submitting: '送信中...'
    },
    
    requiredNote: '* 必須項目'
  }
};
